import React, { useState, useEffect } from "react";
import {
  Container,
  Paper,
  Typography,
  Button,
  Grid,
  InputLabel,
  FormControl,
  InputBase,
} from "@mui/material";
import { styled, alpha } from "@mui/material/styles";
import jwt_decode from "jwt-decode";
import { useUser, useSetUser } from "../globals/UserContext";
import { fetchUserAction } from "../actions/fetchUser";
import { useSetAssignment } from "../globals/AssignmentContext";
import { useSetQuestion } from "../globals/QuestionContext";
const { REACT_APP_GOOGLE_CLIENT_ID } = process.env;

const Login = () => {
  const setUser = useSetUser();
  const setAssignment = useSetAssignment();
  const setQuestion = useSetQuestion();

  useEffect(() => {
    checkGoogleLoad();
  }, []);

  const checkGoogleLoad = () => {
    if (window.hasOwnProperty("google")) {
      initializeGoogle();
    } else {
      setTimeout(() => {
        checkGoogleLoad();
      }, 500);
    }
  };

  const initializeGoogle = () => {
    if (window.hasOwnProperty("google")) {
      /* global google */
      google?.accounts.id.initialize({
        client_id: REACT_APP_GOOGLE_CLIENT_ID,
        callback: handleGoogleResponse,
      });

      google?.accounts.id.renderButton(
        document.getElementById("googleButton"),
        {
          theme: "outline",
          size: "large",
          shape: "circular",
          text: "continue_with",
        }
      );

      //Pausing the rendering of googleButton for 500ms due to weird thing where
      //button rerenders once it notices you're signed in to a google account
      //in the browser. Just a cosmetic thing.
      document.getElementById("googleButton").style.display = "none";

      setTimeout(() => {
        document.getElementById("googleButton").style.display = "block";
      }, 500);
    }
  };

  const handleGoogleResponse = (response) => {
    fetchUserAction(response.credential, setUser, setAssignment, setQuestion);
  };

  return (
    <Grid
      container
      spacing={2}
      justifyContent="center"
      alignItems="center"
      sx={{ paddingTop: "170px" }}
    >
      <Container component="main" maxWidth="xs">
        <Paper
          elevation={3}
          sx={{ display: "flex", flexDirection: "column", padding: "20px" }}
        >
          <Container sx={{ display: "flex", flexDirection: "column" }}>
            <Typography
              variant="h5"
              sx={{
                margin: "5px 0px 20px 0px",
                textAlign: "center",
              }}
            >
              Sign in to your account
            </Typography>

            <div id="googleButton" style={{ margin: "auto" }}></div>
          </Container>
        </Paper>
      </Container>
    </Grid>
  );
};

export default Login;
